<template>
    <div id="campaigns__list" class="overflow-x-auto">
        <div class="border-x-8 border-gray-300 bg-gray-300 mb-1 text-xs lg:text-base font-medium grid grid-cols-10 gap-2 items-center align-middle auto-cols-max w-full py-4">
            <div></div>
            <div class="text-center">{{$t('pages.auctions.control.components.campaign_viewer.lfd')}}</div>
            <div></div>
            <div class="col-span-3">{{$t('pages.auctions.control.components.campaign_viewer.article')}}</div>
            <div class="text-center">{{$t('pages.auctions.control.components.campaign_viewer.amount')}}</div>
            <div class="text-center">{{$t('pages.auctions.control.components.campaign_viewer.ek')}}</div>
            <div class="text-center">{{$t('pages.auctions.control.components.campaign_viewer.avg')}}</div>
            <div>Status</div>
        </div>
        <draggable
            v-model="auctions"
            group="auctions"
            @start="drag=true"
            @end="onDragEnd"
            handle=".item"
            v-if="auctions.length > 0"
        >
            <transition-group>
                <AuctionListItem
                    v-for="(cAuction, index) in auctions"
                    :ranking="index + 1"
                    :key="cAuction.id"
                    :auction="cAuction"
                    :active="active"
                    :view="view"
                    @aclick="auctionClick"
                    @starTeaser="auctionStarTeaser"
                />
            </transition-group>
        </draggable>
        <div class="flex w-full py-4 bg-gray-200" v-if="auctions.length === 0">
          <icon name="clock" class="w-8 h-8 mx-auto animate-spin"/>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import AuctionListItem from "./AuctionListItem";
import AuctionState from "@/mixins/AuctionState";
import Icon from '@/Shared/Icon';
export default {
    name: "CampaignViewer",
    mixins: [
        AuctionState
    ],
    components: {
        AuctionListItem,
        draggable,
        Icon
    },
    props: {
        campaign: Object,
        active: Object,
        view: String
    },
    data() {
      return {
          updatedAuctions: null
      }
    },
    computed: {
        auctions: {
            get() {
                if (null === this.updatedAuctions) {
                    return this.campaign.auctions.sort((a, b) => a.ranking > b.ranking);
                }
                return this.updatedAuctions;
            },
            set(newValue) {
                this.updatedAuctions = newValue;
            }
        }
    },
    watch: {
        campaign: function(v) {
            this.updatedAuctions = null;
        }
    },
    methods: {
        auctionStarTeaser(auctionId, starTeaser) {
            axios.post(route('auctions.star-teaser', {auction: auctionId}), { teaser: starTeaser})
                .then((response) => {
                    console.log(response);
                    if (response.data.status === 0) {
                    } else {

                    }
                })
                .catch((err) => {
                    console.error(err);
                })
        },
        auctionClick(auctionId) {
            this.$emit('aclick');
        },
        onDragEnd() {
            let obj = this;
            let auctionOrders = this.auctions.map(({ id }) => id);
            axios.post(route('campaigns.auction_order', { campaign: obj.campaign.id }), auctionOrders)
                .then((resp) => {
                    if (resp.data.data.status === 0) {
                        this.$emit('campaign:reload', true);
                    }
                })
                .catch((err) => {
                    console.error(err);
                })
        },
    }
}
</script>
